<style type="text/scss" lang="scss">
  .sidebar {
    height: 100vh;
    width: 20%;
    background: #fff;
    position: fixed;
    left: 0;
    top: 0;
    padding: 30px 2%;
    box-shadow: 0 2px 2px 0 rgba(23, 28, 33, 0.06);
    z-index: 99999;
  }

  .logo {
    background-image: url(https://events.thehoneycombproject.org/static/honeycomb/logo_small.png);
    background-repeat: no-repeat;
    left: 10px;
    width: 97px;
    height: 85px;
    margin: 0 0 40px 0;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  ul li {
    color: #4c4c4b;
    font-weight: 300;
    font-size: 21px;
    margin: 0 0 0px 0;
    font-family: proxima-nova, sans-serif;
    -webkit-font-smoothing: auto;
  }

  ul li.active {
    color: #ff6452;
  }

  ul li.active :global(a) {
    color: #ff6452;
  }

  ul li :global(a) {
    color: #4c4c4b;
  }

  ul li ul {
    margin: 8px 0 8px 16px;
  }

  ul li ul li {
    font-size: 17px;
    font-weight: 300;
    margin: 0 0 8px 0;
    line-height: 17px;
  }

  ul li ul.sub li :global(a) {
    color: #4c4c4b;
  }

  ul li ul.sub li.active :global(a) {
    color: #ff6452;
  }
</style>

<script>
  import RouterLink from '../../utils/link';
  import { active } from '../../utils/route.store';
  import { session } from '../../utils/session.store';
  import store from 'store';

  let current = {};

  const unsubscribe = active.subscribe(value => {
    current = value;
  });

  function logout() {
    store.remove('token');
    session.update(s => {
      return {
        loggedIn: null,
        token: null
      };
    });
  }
</script>

<div class="sidebar">
  <div class="logo"></div>
  <ul>
    <li class:active="{current.section === 'programs'}">
      <RouterLink href="/programs">Programs</RouterLink>
      {#if current.section === 'programs'}
      <ul class="sub">
        <li class:active="{current.sub === 'coordinators'}">
          <RouterLink href="/coordinators">Coordinators</RouterLink>
        </li>
        <li class:active="{current.sub === 'leaders'}">
          <RouterLink href="/leaders">Leaders</RouterLink>
        </li>
        <li class:active="{current.sub === 'sponsors'}">
          <RouterLink href="/sponsors">Sponsors</RouterLink>
        </li>
        <li class:active="{current.sub === 'planning'}">
          <RouterLink href="/programs/plan">Planning</RouterLink>
        </li>
      </ul>
      {/if}
    </li>
    <li class:active="{current.section === 'events'}">
      <RouterLink href="/events">Events</RouterLink>
    </li>
    <li class:active="{current.section === 'people'}">
      <RouterLink href="/people">People</RouterLink>
    </li>
    <li class:active="{current.section === 'households'}">
      <RouterLink href="/households">Households</RouterLink>
    </li>
    <li class:active="{current.section === 'reporting'}">
      <RouterLink href="/reporting">Reporting</RouterLink>
    </li>
    <li on:click="{logout}">
      Logout
    </li>
  </ul>
</div>
